import * as React from 'react';
import { useSelector } from 'react-redux';
import { AnimatedContainer } from '../../components/AnimatedContainer';
import { HowItWorks, HowItWorksItem, HowItWorksItemFlight } from '../../components/LandingPageV2/HowItWorks';
import { selectFlightEnabled } from '../../selectors/meta';
import { selectIsAnimationAvailable } from '../../selectors/pageState';

const DEFAULT_ITEMS = [
  {
    step: '1',
    title: 'Вы\u00A0заполняете заявку',
    description: 'Или\u00A0звоните нам\u00A0— консультант уточнит всё\u00A0необходимое',
  },
  {
    step: '2',
    title: 'Мы\u00A0уточняем, о\u00A0каком жильё вы\u00A0мечтаете',
  },
  {
    step: '3',
    title: 'Подбираем квартиры в\u00A0новостройках',
    description:
      'Пришлём варианты, которые подойдут именно вам: с\u00A0необычной планировкой, у\u00A0парка или\u00A0рядом со\u00A0школой',
  },
  {
    step: '4',
    title: 'Если\u00A0понравилась квартира — помогаем её\u00A0забронировать',
  },
  {
    step: '5',
    title: 'Готовимся к\u00A0сделке вместе',
    description: 'Посоветуем\u00A0ипотечную программу, проверим договор и\u00A0поможем с\u00A0документами',
  },
];

const FLIGHT_ITEMS = [
  {
    step: '1',
    title: 'Назначим своего\u00A0консультанта',
    description:
      'Мы\u00A0не\u00A0зависим от\u00A0застройщиков и\u00A0агентств — работаем\u00A0только в\u00A0ваших\u00A0интересах',
  },
  {
    step: '2',
    title: 'Предложим квартиры под\u00A0ваш\u00A0бюджет',
    description:
      'Найдём\u00A0варианты, которые подойдут именно\u00A0вам: с\u00A0нужной планировкой, у\u00A0парка или\u00A0школы',
  },
  {
    step: '3',
    title: 'Оценим риски и\u00A0подводные камни',
    description: 'Зададим застройщику важные вопросы и\u00A0узнаем всё, что\u00A0поможет сделать выбор',
  },
  {
    step: '4',
    title: 'Поможем купить выгоднее',
    description: 'Подберём ипотечную программу и\u00A0договоримся\u00A0с\u00A0застройщиком о\u00A0лучших условиях',
  },
  {
    step: '5',
    title: 'Подготовимся к\u00A0сделке вместе',
    description: 'Проверим договор и\u00A0поможем собрать документы',
  },
];

export const HowItWorksContainer: React.FC = () => {
  const isAnimationAvailable = useSelector(selectIsAnimationAvailable);
  const flightEnabled = useSelector(selectFlightEnabled);
  const items = flightEnabled ? FLIGHT_ITEMS : DEFAULT_ITEMS;
  const title = flightEnabled ? 'Пройдём вместе весь путь' : 'Как\u00A0все\u00A0работает';

  return (
    <HowItWorks title={title} isCenteredTitle={flightEnabled}>
      {items.map((item, index) => (
        <AnimatedContainer key={item.title} isAnimationAvailable={isAnimationAvailable}>
          {flightEnabled ? (
            <HowItWorksItemFlight key={item.title} isLtr={(index + 1) % 2 === 0} {...item} />
          ) : (
            <HowItWorksItem key={item.title} isLtr={(index + 1) % 2 === 0} {...item} />
          )}
        </AnimatedContainer>
      ))}
    </HowItWorks>
  );
};
